import {Asset} from "../entities/Asset";
import {CommandManager} from "../libs/CommandManager";
import {CommandBase} from "./CommandBase";

export class CommandGetThresholdCtrl extends CommandBase{
    selectedItems:any[];
    commandEnabled:boolean = false;
    thresholdTypes:string[] = ["Temperature Upper","Temperature Lower","Acceleration Upper (g)","Battery"];
    selectedThresholdType:string = "Temperature Upper";
    static $inject = ['CommandManager'];
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    getCommandText(asset:Asset):string{
        return asset.vTagID + ":" + this.selectedThresholdType;
    }
    getCommandType():string{
        return "Get Threshold";
    }
}

export class CommandGetThresholdDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdgetthreshold.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandGetThresholdCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.selectedItems.length, (newVal:any)=> {
            controller.selectedItems = scope.selectedItems;
        });
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandGetThresholdDirective();
        }
        return directive;
    }
}
